export const STATUS = {
  published: { label: 'Publicada', cls: 'ok' },
  scheduled: { label: 'Agendada', cls: 'warn' },
  draft: { label: 'Rascunho', cls: 'muted' },
  publishing: { label: 'Publicando', cls: 'info' },
  manual: { label: 'Manual', cls: 'info' },
  partial: { label: 'Parcial', cls: 'warn' },
  failed: { label: 'Falhou', cls: 'err' },
};

export function statusInfo(status) {
  return STATUS[status] || { label: status || 'Desconhecido', cls: 'muted' };
}

export function fmtDate(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

export function fmtDateTimeLocal(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function compact(value) {
  const n = Number(value) || 0;
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return String(n);
}

export function parseLines(text) {
  return String(text || '')
    .split(/[\n,]/)
    .map((line) => line.trim())
    .filter(Boolean);
}

export function manualProgress(pub) {
  const results = (pub && pub.results) || {};
  let total = 0;
  let done = 0;
  Object.values(results).forEach((r) => {
    if (!r || !r.manual) return;
    const accs = r.accounts && Object.keys(r.accounts).length ? r.accounts : null;
    if (accs) {
      Object.values(accs).forEach((a) => {
        total += 1;
        if (a && a.ok) done += 1;
      });
    } else {
      total += 1;
      if (r.ok) done += 1;
    }
  });
  return { total, done, pending: total - done };
}
